/*
##################
## AccountMoney ##
##################

Inputs group for account money.

* OPTIONS
    * profileModel[String]: Model of data. Required.

* EXAMPLE
    <AccountMoney
        profileModel="userProfile.selfEmployed_accountMoney"
        {...this.props}
    />
*/
const React = require('react');
import { RadioButton } from 'components/RadioButton/RadioButton';
import { formatText } from 'core/i18n';

class accountMoney extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { userProfile, profileModel } = this.props;
        const handleSave = this.props.handleSave;
        return (
            <>
                <label>{formatText('contentStepsTitles-accountMoney')}</label>
                <RadioButton
                    profileModel={profileModel}
                    optionsList={[
                        {
                            label: formatText('field-accountMoneyTrue'),
                            value: true,
                        },
                        {
                            label: formatText('field-accountMoneyFalse'),
                            value: false,
                        },
                    ]}
                    isRequired
                    isUpdated={function () {
                        const modelName = profileModel.split('.')[1];
                        handleSave('thirdParty', userProfile[modelName]);
                    }}
                    focusAnimated
                    {...this.props}
                />
            </>
        );
    }
}

module.exports = accountMoney;
